import 'babel-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// 合格したテストのリストを入れる
const PassedTest = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',

  state: {
    items: [] 
  },

  getters: {

    items(state) {
      return state.items;
    }
  },

  mutations: {

    addItem(state, add_item) {
      state.items.push(add_item);
    }
  },

  actions: {

    addItem({ commit, state }, {test_type, test_id}) {

      let add_flg = true;

      const items = state.items;

      // 同じものは追加しない
      for (let i = 0 ; i < items.length ; i++) {

        const item = items[i];

        // console.log('item:' + item.testType + ' - ' + item.testId);
        // console.log('add: ' + test_type + ' - ' + test_id);

        if (item.testType === test_type && item.testId === test_id) {
          add_flg = false;

          break;
        }
      }

      if (add_flg) {
        
        let add_item = {
          testType: test_type,
          testId: test_id
        };

        commit('addItem', add_item);
      }
    }
  }
}

export default new Vuex.Store({
  modules: {
    PassedTest
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js